// eslint-disable-next-line import/prefer-default-export
export enum ProjectStatus {
  IN_PROGRESS = "in_progress",
  DONE = "done",
}
